import { render, staticRenderFns } from "./ownerTransfer.vue?vue&type=template&id=630875a8&scoped=true"
import script from "./ownerTransfer.vue?vue&type=script&lang=js"
export * from "./ownerTransfer.vue?vue&type=script&lang=js"
import style0 from "./ownerTransfer.vue?vue&type=style&index=0&id=630875a8&prod&style=true&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630875a8",
  null
  
)

export default component.exports